import request from 'utils/request';

/**
 * Fetches entire product line including detailed item information and styles data for images
 *
 * @return {Promise}
 */
export async function getPackages(productLineID, quantity, selfHosted) {
	const include = 'items,multipurpose_styles,cloud_styles,office_styles,style_layouts,related_packages';
	const response = await request(`/api/v1/product_lines/${productLineID}`, {
		params: {
			include,
			serializer: 'array',
			quantity,
			self_hosted_pageview_id: selfHosted
		}
	});

	return response;
}

/**
 * Fetches entire product line including detailed item information and styles
 * data for images
 *
 * @return {Promise}
 */
export async function getSpecialOffers(id, quantity) {
	const response = await request(`/api/v1/product_lines/${id}`, {
		params: {
			include: 'special_offers',
			quantity: quantity === 0 ? '' : quantity,
			serializer: 'array'
		}
	});
	return response;
}

export default {
	getPackages,
	getSpecialOffers
};
